module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Manchester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Manchester.png
// module id = 2190
// module chunks = 4